module.exports = __webpack_public_path__ + "static/media/ENGLong3w427@1x.7f8a8ace.webp";